/**
 * Module that
 */

var VRC = VRC || {};

VRC.NavigationView = (function(){

  var init = function(){
     if(!VRC.CurrentVoyage.hasCurrentVoyage()){
        disable();
     }
  };

  var replaceMainMenu = function(isDisabled){
    var $mainMenuWrapper = $('#menu_top_row');
    var html = WELL.Handlebars.VRC.main_menu({disabled : isDisabled});
    $mainMenuWrapper.html(html);
  };

  /**
   * Enable all menu choices.
   */
  var enable = function(){
    replaceMainMenu(false);
  };

  /**
   * Disable all menu choices.
   */
  var disable = function(){
    replaceMainMenu(true);
  };

  /**
   * Sets active menu element
   * @param menuMenuLink the menuItem pressed.
   */
  var setActive = function(menuMenuLink){
    $('.main-menu__link').removeClass('active');
    $(menuMenuLink).addClass('active');
  };

  return {
    init : init,
    enable : enable,
    disable : disable,
    setActive : setActive
  }
})() ;

